import {
    AUTH_LOGIN,
    AUTH_LOGOUT,
    AUTH_CHECK,
    AUTH_ERROR,
    AUTH_GET_PERMISSIONS
} from 'admin-on-rest';
import {checkTokenStatus} from './Fuse/shared/tokenFunctions';

/**
 * Redirect to a requested path
 *
 * @param location
 */
function redirect(location) {
    window.location.href = location;
}

/**
 * Clear User fields from localstorage
 */
export const clearUser = () => {
    localStorage.removeItem('username');
    localStorage.removeItem('email');
    localStorage.removeItem('password');

    localStorage.removeItem('first_name');
    localStorage.removeItem('last_name');
    localStorage.removeItem('sys_op');
    localStorage.removeItem('sys_admin');

    localStorage.removeItem('systems');
    localStorage.removeItem('systems_all');
    localStorage.removeItem('sections');
    localStorage.removeItem('sections_all');
    localStorage.removeItem('locations');
    localStorage.removeItem('locations_all');
    localStorage.removeItem('dbas');
    localStorage.removeItem('dbas_all');
    localStorage.removeItem('districts');
    localStorage.removeItem('districts_all');

    localStorage.removeItem('locked');
    localStorage.removeItem('active');

    localStorage.removeItem('system');
    localStorage.removeItem('mode');
    localStorage.removeItem('token');
};

export default (type, params) => {

    let isSysop, isSysadmin, isLocked, isActive;

    // Auth: Login
    if (type === AUTH_LOGIN) {
        // console.log('---------- AUTH LOGIN params: ', params);

        // Login returns a User object
        const {system, user} = params;
        localStorage.setItem('system', system);
        localStorage.setItem('mode', 'live');
        localStorage.setItem('email', user.email);

        localStorage.setItem('first_name', user.first_name);
        localStorage.setItem('last_name', user.last_name);
        localStorage.setItem('sys_op', user.sys_op);
        localStorage.setItem('sys_admin', user.sys_admin);
        localStorage.setItem('systems_all', user.systems_all);
        localStorage.setItem('sections_all', user.sections_all);
        localStorage.setItem('locations_all', user.locations_all);
        localStorage.setItem('dbas_all', user.dbas_all);
        localStorage.setItem('districts_all', user.districts_all);

        localStorage.setItem('locked', user.locked);
        localStorage.setItem('active', user.active);

        // Store User arrays
        if (user.systems) {
            localStorage.setItem('systems', JSON.stringify(user.systems));
        }
        if (user.sections) {
            localStorage.setItem('sections', JSON.stringify(user.sections));
        }
        if (user.locations) {
            localStorage.setItem('locations', JSON.stringify(user.locations));
        }
        if (user.dbas) {
            localStorage.setItem('dbas', JSON.stringify(user.dbas));
        }
        if (user.districts) {
            localStorage.setItem('districts', JSON.stringify(user.districts));
        }

        if (user.email) {
            return Promise.resolve();
        }
    }

    // Auth: Logout
    if (type === AUTH_LOGOUT) {
        clearUser();
        localStorage.removeItem('auth_method');
        return Promise.resolve();
    }

    // Auth: Error
    if (type === AUTH_ERROR) {
        // console.log('---------- AUTH ERROR params: ', params);
        return Promise.resolve();
    }

    // Auth: Check (called on all Navigation checks)
    if (type === AUTH_CHECK) {
        // console.log('---------- AUTH CHECK params: ', params);

        // Reject if the user has no token
        const token = localStorage.getItem('token');
        if (!token) {
            return Promise.reject('No Authorization Token. Please log in.')
                .then(function () {
                }, function (error) {
                    redirect('/#/login');
                });
        } else {
            // Check existing token for expiration
            checkTokenStatus(token);
        }

        isSysop = localStorage.getItem('sys_op');
        isSysadmin = localStorage.getItem('sys_admin');
        // Reject if the user is neither a Sysop nor a Sysadmin
        if ((!isSysop && !isSysadmin)) {
            return Promise.reject({redirectTo: '/NoAccess'});
        }
        // Reject if the user is accessing a Sysop area and is not a Sysop
        if (params.resource === 'Sysops') {
            if (!isSysop || isSysop === false) {
                return Promise.reject({redirectTo: '/NoAccess'});
            }
        }

        // Reject if the user is locked or inactive
        isLocked = localStorage.getItem('locked');
        isActive = localStorage.getItem('active');
        if ((isLocked && !isActive)) {
            clearUser();
            redirect('/#/login');
        }

        return Promise.resolve();
    }

    // Auth: Permissions (called on Login checks)
    if (type === AUTH_GET_PERMISSIONS) {
        // console.log('---------- AUTH GET PERMISSIONS params: ', params);

        // Must have email stored
        let userEmail = localStorage.getItem('email');
        if (!userEmail) {
            return Promise.reject('No email; please log in.')
                .then(function () {
                }, function (error) {
                    console.log('No email address. Please log in.');
                    redirect('/#/login');
                });
        }

        // Reject if the user is locked or inactive
        isLocked = localStorage.getItem('locked');
        isActive = localStorage.getItem('active');
        if ((isLocked && !isActive)) {
            clearUser();
            redirect('/#/login');
        }

        // Only Sysops can access the System Admin
        const isSysop = localStorage.getItem('sys_op');
        if (isSysop === 'true') {
            return Promise.resolve('sys_op');
        }
    }

    return Promise.reject('Cannot access the CloudSent POS System Admin.')
        .then(function () {
        }, function (error) {
            console.log('Promise reject: Cannot access the CloudSent POS System Admin.');
        });
};



// WEBPACK FOOTER //
// ./src/authClient.js